// @ts-strict

import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * @ngModule SharedModule
 * @description
 *
 * Pipe responsible for changing date format
 *
 * @usageNotes
 *
 * Usage:
 *   date | changeDateFormat:'at'
 * Example:
 *   {{ '18.10.2020, 7:20' | changeDateFormat }}
 *   formats to: 18 September 2020 at 7:20
 */
@Pipe({
  name: 'changeDateFormat'
})
export class ChangeDateFormatPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  public static Months = new Map([
    ['01', 'january_declination'],
    ['02', 'february_declination'],
    ['03', 'march_declination'],
    ['04', 'april_declination'],
    ['05', 'may_declination'],
    ['06', 'june_declination'],
    ['07', 'july_declination'],
    ['08', 'august_declination'],
    ['09', 'september_declination'],
    ['10', 'october_declination'],
    ['11', 'november_declination'],
    ['12', 'december_declination']
  ]);

  // Date direction
  // 'normal' e.g. 20 January 2021
  // 'reversed e.g. 2021 January 20
  transform(key: string | null, mode: string, direction?: string, hourOption?: string): string {
    if (!key) return '';

    const getDate = key.split(' ')[0];
    const getHour = hourOption === 'nohour' ? '' : key.split(' ')[1];
    const getMonth = getDate.split('-')[1] || getDate.split('.')[1];
    const month = ChangeDateFormatPipe.Months.has(getMonth) ? ChangeDateFormatPipe.Months.get(getMonth) : key.toString();
    let translatedMonth = '';
    this.translate.stream(`view_translations.${month}`).subscribe(translate => {
      translatedMonth = translate;
    });
    const splitDate = getDate.split('-').length > 1 ? getDate.split('-') : getDate.split('.');
    let hourLink = '';
    const year = splitDate[2].replace(',', '');
    if (mode === 'at') {
      this.translate.stream('view_translations.at').subscribe(transl => {
        hourLink = transl;
      });
    } else {
      hourLink = ',';
    }
    if (hourOption === 'nohour') {
      hourLink = '';
    }
    let finalDateFormat;
    if (direction === 'reversed' || direction === undefined) {
      finalDateFormat = `${year} ${translatedMonth} ${splitDate[0]} ${hourLink} ${getHour}`;
    } else {
      finalDateFormat = `${splitDate[0]} ${translatedMonth} ${year} ${hourLink} ${getHour}`;
    }

    return finalDateFormat;
  }
}
